<div class="panel-header">
  <h4>Routes</h4>
</div>
<div class="panel-body flex-fill" *ngIf="{ routes: routes$ | async } as p">
  <div class="static-container d-flex align-items-center justify-content-start">
    <button
      class="btn btn-text-dark btn-icon-only mr-1"
      [ngClass]="{
        'disabled-button': p.routes?.length > 7
      }"
      (click)="p.routes?.length > 7 ? $event.stopPropagation() : newRoute()"
      [tooltip]="
        p.routes?.length > 7
          ? 'You have the maximum of 8 routes open'
          : 'New Route'
      "
      container="body"
      [adaptivePosition]="false"
      placement="bottom"
      [disabled]="(profilesLoaded$ | async) === false"
    >
      <i class="modus-icons">add</i>
    </button>
    <div>
      <button
        class="btn btn-text-dark btn-icon-only mr-1"
        *ngIf="routeService.showOpenRoutePanel()"
        [ngClass]="{
          'disabled-button': p.routes?.length > 7
        }"
        (click)="
          p.routes?.length > 7 ? $event.stopPropagation() : showSavedRoute()
        "
        [tooltip]="
          p.routes?.length > 7
            ? 'You have the maximum of 8 routes open'
            : 'Open Saved Route'
        "
        container="body"
        [adaptivePosition]="false"
        placement="bottom"
      >
        <i class="modus-icons">cloud_download</i>
      </button>
    </div>
    <!-- <button
      class="btn btn-text-dark btn-icon-only mr-1"
      (click)="deleteAllRoutes()"
      [disabled]="(isRoutePanelEmpty$ | async) === true"
      tooltip="Delete All Routes"
      container="body"
      [adaptivePosition]="false"
      placement="bottom"
    >
      <i class="modus-icons">trash</i>
    </button> -->
    <!-- <button
      class="btn btn-text-dark btn-icon-only ml-auto"
      (click)="(defaultRouteOptions)"
      tooltip="Default Route Options"
      container="body"
      [adaptivePosition]="false"
      placement="bottom"
    >
      <i class="modus-icons">gear</i>
    </button> -->
  </div>
  <div class="scroll-container p-2" *ngIf="profilesLoaded$ | async">
    <app-route
      *ngFor="let route of p.routes; let routeIndex = index"
      [route]="route"
    ></app-route>
  </div>
</div>
